import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { logout } from "../services/auth";
import { useAuthStore } from "../stores/auth";

export function Logout() {
  const navigate = useNavigate();
  const authStore = useAuthStore();
  const setIsAuthRef = useRef(authStore.setIsAuth);
  const navigateRef = useRef(navigate);

  useEffect(() => {
    (async () => {
      await logout();
      setIsAuthRef.current(false);
      navigateRef.current("/");
    })();
  });

  return null;
}
